<template lang="pug">

    .photo(v-if='object.image.src', :class="`photo--${realResize} ${typeClass}`", v-inview:class="['entered']")

        .photo__wrap(:style="style")

            app-image(:lazy-src="src", :lazy-srcset="srcset", :alt="object.image.alt", :class="imgClass")

</template>

<script>
/* Components */
import AppImage from '@/components/AppImage.vue';
import Decoration from '@/components/illustrations/Decoration.vue';
// import InViewOffMixin from '@/assets/js/viscom/viscomjs/utils/InViewOffMixin';

export default {
    name: 'photo',
    props: {
        object: {
            type: Object,
            default: null
        },

        base: {
            type: String,
            default: ''
        },

        resize: {
            type: String,
            default: 'contain'
        },
        active: {
            default: false,
            type: Boolean
        }
    },

    components: {
        AppImage,
        Decoration
    },

    computed: {
        src() {
            return this.base + (this.object.image.src || '');
        },

        width() {
            return this.object.image.width || null;
        },

        height() {
            return this.object.image.height || null;
        },

        realResize() {
            return this.object.image.customResize || this.resize;
        },

        typeClass() {
            if (!this.object.types || !(this.object.types instanceof Array)) return '';
            return 'photo--' + this.object.types.join(' photo--');
        },

        imgClass() {
            if (!this.width || !this.height) return '';
            return 'aspect-ratio';
        },

        srcCompact() {
            return this.object.image.srcCompact;
        },

        srcset() {
            if (!this.srcCompact) return null;
            return `${this.src} 1400w, ${this.base}${this.srcCompact} 800w`;
        },

        aspectRatio() {
            // Calculate the aspect ratio of the image
            // if the width and the height are given.
            if (!this.width || !this.height) return null;

            return (this.height / this.width) * 100;
        },

        style() {
            const style = {height: '100%'};

            if (this.realResize === 'contain') return style;

            if (this.aspectRatio) {
                style.height = 0;
                style.paddingBottom = `${this.aspectRatio}%`;
            }

            return style;
        }
    }
};
</script>

<style lang="scss">
//
@import '../../assets/css/vars';
//
.photo {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        // min-height: 50vh;
        overflow: hidden;
    }

    &__wrap {
        position: relative;
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 0;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            height: auto !important;
            padding-bottom: 0 !important;
        }
    }

    .app-image {
        background-color: rgba(255, 255, 255, 0.1);
        width: 100%;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            max-height: unset;
            width: 100%;
        }
    }

    // TYPES:
    &--width-80 {
        .app-image {
            width: 80.2%;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 100%;
            }
        }
    }

    &--width-69 {
        .app-image {
            width: 69.23%;

            @media (--viewport-mobile), (--viewport-tablet-pt) {
                width: 100%;
            }
        }
    }

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        &--mobile-car {
            .photo {
                &__wrap {
                    height: 0 !important;
                    padding-bottom: 100% !important;
                    overflow: hidden;
                }
            }

            .app-image {
                position: absolute;
                top: 50%;
                left: 0;
                bottom: 0;
                transform: translate(-20%, -50%);
                width: auto;
                max-width: unset;
                height: 100%;

                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    position: relative;
                    top: auto;
                    left: auto;
                    transform: none;
                }
            }
        }
    }

    // ALIGN
    &--right {
        align-items: flex-end;

        .photo {
            &__wrap {
                align-items: flex-end;
            }
        }
    }

    // Enter animation
    &--alpha {
        transition: opacity 0.3s ease 0.15s;

        &:not(.entered) {
            opacity: 0;
        }
    }

    &__decoration {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>
